import React from 'react';
import { get } from 'lodash';
import { Translate, TranslateHTML, withTranslate } from 'core/translate';
import PackageCard from '../../common/options/packageCard/PackageCard';
import SimpleOptionCard from '../../common/options/SimpleOptionCard';
import { useTranslate } from '../../../core/translate';

const getOptionDescription = (option) =>
  option.formattedConfig || option.shortCFD || option.description;

const OptionConflictWithUserSelection = ({
  option,
  selection,
  conflictConfig,
  onChange,
}) => {
  const { selected } = option;

  const userSelectionOptions = get(
    conflictConfig,
    'config.toggleCheck.userChoiceOptions',
    []
  );
  const translate = useTranslate();
  const specialEditionLabel = translate('package.marker.special.edition');
  return (
    <>
      <div className="option-conflict__header">
        {selected ? (
          <TranslateHTML
            value="conflict.removing.require.action.header.choice.v3"
            description={getOptionDescription(option)}
          />
        ) : (
          <TranslateHTML
            value="conflict.adding.require.action.header.choice.v3"
            description={getOptionDescription(option)}
          />
        )}
      </div>
      <div className="option-conflict-containter__inner">
        <span className="modal-body__label option-conflict__label">
          <Translate value="component.options.add" />
        </span>

        <div className=" option-conflict__grid">
          {userSelectionOptions.map((option) =>
            option?.hierarchy?.step === 'packages' ? (
              <PackageCard
                key={option.code}
                analyticsKey="configuration assistant"
                option={option}
                hideInfoIcon={true}
                checked={selection === option}
                onChange={onChange}
                showAllOptions={true}
                optionMarker={
                  option.hierarchy.category === 'special.edition'
                    ? specialEditionLabel
                    : ''
                }></PackageCard>
            ) : (
              <SimpleOptionCard
                role="checkbox"
                type="option"
                analyticsKey="configuration assistant"
                key={option.code}
                option={option}
                checked={selection === option}
                onChange={onChange}
                hideInfoIcon={true}
              />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default withTranslate(OptionConflictWithUserSelection);
